// @flow
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, matchPath } from 'react-router-dom';

import { Button } from '@locus-taxy/neo-ui';
import { RouterLink } from 'common/components/core/link/RouterLink';
import queryString from 'query-string';
import loginIds from 'common/tests/login/loginIds.json';

import useResolvedClientId from 'common/hooks/useResolvedClientId';

const LoginButton = (): React.Node => {
    const { t } = useTranslation('settings');
    const location = useLocation();
    const linkRef = React.createRef();

    React.useEffect(() => {
        if (linkRef.current) {
            linkRef.current.focus();
        }
    }, [linkRef]);

    // NOTE: we can switch clientId on login screen
    // so checking fromLocation is of same client
    // if not same ignore fromLocation
    const { localResolvedClientId, providerId } = useResolvedClientId();

    const fromLocation = React.useMemo(() => {
        const match = matchPath(location.state?.fromLocation?.pathname || '', {
            path: '/client/:clientId'
        });
        return match?.params.clientId === localResolvedClientId
            ? location.state?.fromLocation
            : undefined;
    }, [location, localResolvedClientId]);

    return (
        <RouterLink
            style={{
                display: 'flex',
                flexDirection: 'column'
            }}
            disabled={!localResolvedClientId}
            to={{
                pathname: '/login/sso',
                search: queryString.stringify({
                    clientId: localResolvedClientId,
                    providerId: providerId || undefined
                }),
                state: {
                    ...location.state,
                    fromLocation
                }
            }}
        >
            <Button
                ref={linkRef}
                data-test-id={loginIds.buttons.redirectToSSO}
                disabled={!localResolvedClientId}
                type="submit"
                appearance="solid"
                palette="primary"
                size="large"
            >
                {t('login')}
            </Button>
        </RouterLink>
    );
};

export default LoginButton;
